import script from "./PaymentEligibilitySeal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentEligibilitySeal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__